// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shadow {
  width: 160px;
}

.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.calender-selection {
  margin-top: 5px;
}

.calender-selection .control-select-men {
  display: inline-block;
  float: left;
}

.calender-selection .control-select-filter-men {
  display: inline-block;
  float: left;
}

.assesmenttxt {
  color: #717171;
}

.assessmentDiv {
  margin-top: 1.2rem;
  margin-bottom: 1.2rem;
}

.assesmentUnderline {
  text-decoration: underline;
}

.piechartParent {
  width: 90%;
  margin: 0 auto;
}

.piechartContainer {
  background-color: white;
  border-radius: 4px;
}

.piechartBlock {
  background-color: rgb(8, 20, 47);
  border-radius: 0 !important;
}

.piechartBlock .block-limiter {
  padding: 0px !important;
}

.piechartTitle {
  font-size: 17px;
  color: #000;
  font-weight: 600;
  text-align: center;
  font-style: normal;
  font-family: "Source Sans Pro", sans-serif;
}

.piechartSubTitle {
  font-size: 21px;
  color: #000;
  font-weight: 600;
  text-align: center;
  margin-top: 3px;
}

.piechartSubTitle2 {
  font-size: 1.05rem;
  color: #717171;
  text-align: center;
  margin-top: 10px;
}

.piechartSubTitleGrey {
  color: #717171;
}

.piechartContainer {
  padding: 18px;
  width: 100%;
}

.donut {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  font-family: sans-serif !important;
  letter-spacing: -0.05em;
}

.donut-container {
  display: block;
  float: left;
  width: 50%;
}

.description-container {
  display: block;
  float: left;
  width: 60%;
  color: #000;
  padding-top: 15px;
}

.description-container b {
  margin-bottom: 10px;
  color: #000;
  display: block;
}

.donut-container .donut {
  width: 100px !important;
  height: 100px !important;
  margin: 10px;
  align-self: flex-start;
  color: #000;
}

.donut-container .donut-value {
  font-size: 25px !important;
}

.donut-container .donut-change.intent-success {
  font-size: 15px !important;
}

.dashboard-header-group-inner {
  min-width: 140px;
  margin: 10px;
  flex: 1 1 auto;
}

.description-container-label {
  font-size: 15px;
  font-weight: 400;
  color: #8ba7c4;
}

.description-container-description {
  font-size: 13px;
}

.description-container-description-span {
  font-size: 13px;
  display: block;
  margin-bottom: 15px;
}

.button-filters {
  margin-bottom: 15px;
}

.button-filters button {
  margin-right: 10px;
  min-width: 60px !important;
  color: #afafaf !important;
  border-color: #afafaf !important;
  border-radius: 8px !important;
}

.button-filters .button .text {
  font-size: 11px;
}

.description-container-description button {
  background-color: #EEF9F8 !important;
  min-width: 60px !important;
  border-color: #EEF9F8 !important;
  box-shadow: none !important;
}

.description-container-description .reset-button {
  padding: 5px;
  border-radius: 4px;
}

.description-container-description .reset-button .button-icon-main {
  border-radius: 0;
  background-color: inherit;
  height: 25px;
  width: 25px;
}

.description-container-description .reset-button .button-icon-main .icon {
  color: #2e968f;
}

.description-container-description .reset-button .label {
  text-transform: inherit;
  padding-right: 10px;
  color: #8a8a8a;
  font-weight: normal;
}

.description-container-description .reset-button .button-icon-main svg {
  height: 20px;
  width: 20px;
}

.piechartContainer .gauge-chart {
  height: 120px !important;
}

.carousel-dots-dashboard {
  display: block;
}

.carousel-dots-dashboard li {
  border-radius: 50%;
  padding: 2px !important;
}

.carousel-dots-dashboard li.slick-active {
  border: 1px solid #4FADA6;
}

.carousel-dots-dashboard li:not(.slick-active) {
  border: 1px solid lightgray;
}

.carousel-dots li.slick-active button {
  opacity: 0.75;
  background-color: #4FADA6 !important;
  border-radius: 50%;
}

.carousel-dots li, .carousel-dots li button {
  width: unset !important;
  height: unset !important;
}

.carousel-dots li button:before {
  color: unset !important;
}

.dashboard-legend {
  color: black;
  background-color: unset !important;
}

.dashboard-legend .legend-items {
  flex-direction: row;
}

.dashboard-legend UL > LI .swatch {
  border-radius: 50% !important;
}

.legend UL > LI {
  margin: 5px 7px 0 0;
}

.dashboard-card-bg-div-1 {
  height: 270px;
}

.dashboard-card-bg-div-2 {
  height: 80px;
}

.dashboard-card {
  position: relative;
  top: -350px;
}

.row-separater {
  display: flex;
  height: 120px;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}

.property-display1 {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 120px !important;
}

.property-display2 {
  width: 49%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
}

.missed-standard.property-display2 {
  width: 68%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
}

.carousel-dots-benchmark-dashboard li.carousel-dots-active {
  box-sizing: border-box;
  box-sizing: border-box;
  background: #4FADA6;
  height: 4px !important;
  width: 30px !important;
}

.carousel-dots-benchmark-dashboard li:not(.carousel-dots-active) {
  box-sizing: border-box;
  box-sizing: border-box;
  background: grey;
  height: 4px !important;
  width: 30px !important;
}

.carousel-dots-benchmark-dashboard li.carousel-dots-active button:before {
  color: #4FADA6 !important;
  top: -8px !important;
  left: -15px !important;
  font-size: 40px !important;
  opacity: 1 !important;
  width: 30px;
  height: 30px;
  background: #FFFFFF;
  border: 0.6px solid #4FADA6;
  border-radius: 50%;
}

.carousel-dots-benchmark-dashboard li button:before {
  line-height: 30px !important;
  top: -8px !important;
  left: -15px !important;
  font-size: 40px !important;
  opacity: 1 !important;
  color: grey !important;
}

.piechartTitleChange {
  display: inline-block;
  padding: auto;
  width: 50%;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  position: relative;
  bottom: 90px;
}

.piechartTitleChangeSpan {
  border-radius: 20px;
  padding-left: 10px;
  padding-right: 10px;
}

.piechartTitleChangeSpanIcon {
  font-size: 10px;
  bottom: 2px;
  position: relative;
  padding-right: 5px;
}

.legend {
  margin-left: auto !important;
}

.brand-hotel-selector .hotel-selection-dropdown-none .control-select-menu-addon {
  display: none;
}

.brand-hotel-selector .hotel-selector-primary {
  white-space: nowrap;
}

.brandhotelselector .hotel-selection-dropdown-none .control-select-menu-addon {
  display: none;
}

.hotel-selection-dropdown-none.control-select-menu:hover,
.hotel-selection-dropdown-none.control-select-menu:focus {
  text-decoration: none !important;
}

.blur {
  filter: url(#gaussian-blur);
  filter: blur(7px);
  -webkit-filter: blur(7px);
  position: fixed;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  opacity: 0;
  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
  color: #666;
  text-align: center;
  overflow-y: hidden;
}

.z-index-100 {
  z-index: 100;
  position: fixed;
  top: 50%;
  left: 44%;
  right: 50%;
  bottom: 50%;
}

.profile-view-container {
  position: fixed;
  top: 160px;
  height: 100vh !important;
  background: #08142f;
  width: 100%;
  z-index: 1;
}

.centered-container {
  display: flex;
  padding-top: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: left; /* Center text inside each div */
}

.compset-font .bp3-popover-target .control-select-menu-inner .control-select-menu-select {
  font-size: 11px;
}

.mt-250 {
  margin-top: 250px;
}

.mb-50 {
  margin-bottom: 50px;
}

.pending-assessment {
  top: 200px;
  position: absolute;
}

.hotel-selector-primary {
  font-size: 18px !important;
  line-height: 20px !important;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AACA;EAAQ,YAAA;AACR;;AACA;EAAwB,iBAAA;EAAkB,kBAAA;EAAmB,mBAAA;AAK7D;;AAJA;EAA6B,eAAA;AAQ7B;;AAPA;EAAY,YAAA;AAWZ;;AAVA;EAAgB,mBAAA;AAchB;;AAbA;EAAoB,eAAA;AAiBpB;;AAfA;EAAwC,qBAAA;EAAuB,WAAA;AAoB/D;;AAnBA;EAA+C,qBAAA;EAAuB,WAAA;AAwBtE;;AAtBA;EAAc,cAAA;AA0Bd;;AAzBA;EAAe,kBAAA;EAAoB,qBAAA;AA8BnC;;AA7BA;EAAoB,0BAAA;AAiCpB;;AAhCA;EAAiB,UAAA;EAAY,cAAA;AAqC7B;;AApCA;EAAmB,uBAAA;EAAwB,kBAAA;AAyC3C;;AAxCA;EAAe,gCAAA;EAAiC,2BAAA;AA6ChD;;AA5CA;EAA8B,uBAAA;AAgD9B;;AA/CA;EAAe,eAAA;EAAiB,WAAA;EAAW,gBAAA;EAAkB,kBAAA;EAAoB,kBAAA;EAAoB,0CAAA;AAwDrG;;AAvDA;EAAkB,eAAA;EAAiB,WAAA;EAAW,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;AA+DpF;;AA9DA;EAAmB,kBAAA;EAAoB,cAAA;EAAe,kBAAA;EAAmB,gBAAA;AAqEzE;;AApEA;EAAsB,cAAA;AAwEtB;;AAvEA;EAAmB,aAAA;EAAc,WAAA;AA4EjC;;AA3EA;EAAQ,cAAA;EAAe,aAAA;EAAc,mBAAA;EAAoB,uBAAA;EAAwB,gBAAA;EAAiB,kBAAA;EAAmB,kCAAA;EAAmC,uBAAA;AAsFxJ;;AArFA;EAAiB,cAAA;EAAgB,WAAA;EAAY,UAAA;AA2F7C;;AA1FA;EAAuB,cAAA;EAAgB,WAAA;EAAY,UAAA;EAAY,WAAA;EAAY,iBAAA;AAkG3E;;AAjGA;EAAyB,mBAAA;EAAqB,WAAA;EAAa,cAAA;AAuG3D;;AAtGA;EAAwB,uBAAA;EAAwB,wBAAA;EAAyB,YAAA;EAAa,sBAAA;EAAuB,WAAA;AA8G7G;;AA7GA;EAA8B,0BAAA;AAiH9B;;AAhHA;EAA8C,0BAAA;AAoH9C;;AAnHA;EAA+B,gBAAA;EAAiB,YAAA;EAAa,cAAA;AAyH7D;;AAxHA;EAA8B,eAAA;EAAgB,gBAAA;EAAiB,cAAA;AA8H/D;;AA7HA;EAAoC,eAAA;AAiIpC;;AAhIA;EAAwC,eAAA;EAAiB,cAAA;EAAgB,mBAAA;AAsIzE;;AArIA;EAAgB,mBAAA;AAyIhB;;AAxIA;EAAuB,kBAAA;EAAoB,0BAAA;EAA4B,yBAAA;EAA0B,gCAAA;EAAgC,6BAAA;AAgJjI;;AA/IA;EAA8B,eAAA;AAmJ9B;;AAlJA;EAA0C,oCAAA;EAAsC,0BAAA;EAA4B,gCAAA;EAAgC,2BAAA;AAyJ5I;;AAxJA;EAAiD,YAAA;EAAa,kBAAA;AA6J9D;;AA5JA;EAAmE,gBAAA;EAAiB,yBAAA;EAA2B,YAAA;EAAc,WAAA;AAmK7H;;AAlKA;EAAyE,cAAA;AAsKzE;;AArKA;EAAwD,uBAAA;EAAwB,mBAAA;EAAqB,cAAA;EAAgB,mBAAA;AA4KrH;;AA3KA;EAAuE,YAAA;EAAc,WAAA;AAgLrF;;AA/KA;EAAgC,wBAAA;AAmLhC;;AAjLA;EACI,cAAA;AAoLJ;;AAlLA;EACI,kBAAA;EACA,uBAAA;AAqLJ;;AAlLA;EACI,yBAAA;AAqLJ;;AAlLA;EACI,2BAAA;AAqLJ;;AAlLA;EACI,aAAA;EACA,oCAAA;EACA,kBAAA;AAqLJ;;AAlLA;EACI,uBAAA;EACA,wBAAA;AAqLJ;;AAnLA;EACI,uBAAA;AAsLJ;;AApLA;EACI,YAAA;EAEA,kCAAA;AAsLJ;;AAnLA;EACI,mBAAA;AAsLJ;;AApLA;EACI,6BAAA;AAuLJ;;AArLA;EACI,mBAAA;AAwLJ;;AArLA;EACI,aAAA;AAwLJ;;AAtLA;EACI,YAAA;AAyLJ;;AAxLC;EACG,kBAAA;EACA,WAAA;AA2LJ;;AAxLA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AA2LJ;;AAxLA;EAAmB,cAAA;EAAe,aAAA;EAAc,sBAAA;EAAwB,mBAAA;EAAqB,wBAAA;AAgM7F;;AA/LA;EAAmB,UAAA;EAAY,cAAA;EAAe,aAAA;EAAc,sBAAA;EAAwB,mBAAA;EAAoB,iBAAA;AAwMxG;;AAvMA;EACI,UAAA;EAAY,cAAA;EAAe,aAAA;EAAc,sBAAA;EAAwB,mBAAA;EAAoB,iBAAA;AA+MzF;;AA7MA;EAA2D,sBAAA;EACvD,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAiNJ;;AA/MI;EAAiE,sBAAA;EAC7D,sBAAA;EACJ,gBAAA;EACA,sBAAA;EACA,sBAAA;AAmNJ;;AAjNI;EACI,yBAAA;EACA,oBAAA;EACJ,sBAAA;EACA,0BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAoNJ;;AAlNI;EACI,4BAAA;EACA,oBAAA;EACJ,sBAAA;EACA,0BAAA;EACA,qBAAA;EACA,sBAAA;AAqNJ;;AA3MI;EACA,qBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AA8MJ;;AA5MI;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA+MJ;;AA5MI;EACI,eAAA;EACJ,WAAA;EACA,kBAAA;EACA,kBAAA;AA+MJ;;AA5MI;EACI,4BAAA;AA+MR;;AA5MA;EACI,aAAA;AA+MJ;;AA5MA;EACE,mBAAA;AA+MF;;AA7MA;EACE,aAAA;AAgNF;;AA7MA;;EAEI,gCAAA;AAgNJ;;AA7MA;EACI,2BAAA;EACF,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EAIA,wDAAA;EACA,yCAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAgNF;;AA7MA;EACI,YAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAgNJ;;AA7MA;EACI,eAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AAgNJ;;AA7MA;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA,EAAA,gCAAA;AAgNJ;;AA7MA;EACI,eAAA;AAgNJ;;AA9MA;EACI,iBAAA;AAiNJ;;AA/MA;EACI,mBAAA;AAkNJ;;AAhNA;EACA,UAAA;EACE,kBAAA;AAmNF;;AAhNA;EACI,0BAAA;EACA,4BAAA;AAmNJ","sourcesContent":[".shadow {\n  width: 160px;\n}\n\n.header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.calender-selection {\n  margin-top: 5px;\n}\n\n.calender-selection .control-select-men {\n  display: inline-block;\n  float: left;\n}\n\n.calender-selection .control-select-filter-men {\n  display: inline-block;\n  float: left;\n}\n\n.assesmenttxt {\n  color: #717171;\n}\n\n.assessmentDiv {\n  margin-top: 1.2rem;\n  margin-bottom: 1.2rem;\n}\n\n.assesmentUnderline {\n  text-decoration: underline;\n}\n\n.piechartParent {\n  width: 90%;\n  margin: 0 auto;\n}\n\n.piechartContainer {\n  background-color: white;\n  border-radius: 4px;\n}\n\n.piechartBlock {\n  background-color: rgb(8, 20, 47);\n  border-radius: 0 !important;\n}\n\n.piechartBlock .block-limiter {\n  padding: 0px !important;\n}\n\n.piechartTitle {\n  font-size: 17px;\n  color: #000;\n  font-weight: 600;\n  text-align: center;\n  font-style: normal;\n  font-family: \"Source Sans Pro\", sans-serif;\n}\n\n.piechartSubTitle {\n  font-size: 21px;\n  color: #000;\n  font-weight: 600;\n  text-align: center;\n  margin-top: 3px;\n}\n\n.piechartSubTitle2 {\n  font-size: 1.05rem;\n  color: #717171;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.piechartSubTitleGrey {\n  color: #717171;\n}\n\n.piechartContainer {\n  padding: 18px;\n  width: 100%;\n}\n\n.donut {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  font-family: sans-serif !important;\n  letter-spacing: -0.05em;\n}\n\n.donut-container {\n  display: block;\n  float: left;\n  width: 50%;\n}\n\n.description-container {\n  display: block;\n  float: left;\n  width: 60%;\n  color: #000;\n  padding-top: 15px;\n}\n\n.description-container b {\n  margin-bottom: 10px;\n  color: #000;\n  display: block;\n}\n\n.donut-container .donut {\n  width: 100px !important;\n  height: 100px !important;\n  margin: 10px;\n  align-self: flex-start;\n  color: #000;\n}\n\n.donut-container .donut-value {\n  font-size: 25px !important;\n}\n\n.donut-container .donut-change.intent-success {\n  font-size: 15px !important;\n}\n\n.dashboard-header-group-inner {\n  min-width: 140px;\n  margin: 10px;\n  flex: 1 1 auto;\n}\n\n.description-container-label {\n  font-size: 15px;\n  font-weight: 400;\n  color: #8ba7c4;\n}\n\n.description-container-description {\n  font-size: 13px;\n}\n\n.description-container-description-span {\n  font-size: 13px;\n  display: block;\n  margin-bottom: 15px;\n}\n\n.button-filters {\n  margin-bottom: 15px;\n}\n\n.button-filters button {\n  margin-right: 10px;\n  min-width: 60px !important;\n  color: #afafaf !important;\n  border-color: #afafaf !important;\n  border-radius: 8px !important;\n}\n\n.button-filters .button .text {\n  font-size: 11px;\n}\n\n.description-container-description button {\n  background-color: #EEF9F8 !important;\n  min-width: 60px !important;\n  border-color: #EEF9F8 !important;\n  box-shadow: none !important;\n}\n\n.description-container-description .reset-button {\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.description-container-description .reset-button .button-icon-main {\n  border-radius: 0;\n  background-color: inherit;\n  height: 25px;\n  width: 25px;\n}\n\n.description-container-description .reset-button .button-icon-main .icon {\n  color: #2e968f;\n}\n\n.description-container-description .reset-button .label {\n  text-transform: inherit;\n  padding-right: 10px;\n  color: #8a8a8a;\n  font-weight: normal;\n}\n\n.description-container-description .reset-button .button-icon-main svg {\n  height: 20px;\n  width: 20px;\n}\n\n.piechartContainer .gauge-chart {\n  height: 120px !important;\n}\n\n.carousel-dots-dashboard {\n  display: block;\n}\n\n.carousel-dots-dashboard li {\n  border-radius: 50%;\n  padding: 2px !important;\n}\n\n.carousel-dots-dashboard li.slick-active {\n  border: 1px solid #4FADA6;\n}\n\n.carousel-dots-dashboard li:not(.slick-active) {\n  border: 1px solid lightgray;\n}\n\n.carousel-dots li.slick-active button {\n  opacity: 0.75;\n  background-color: #4FADA6 !important;\n  border-radius: 50%;\n}\n\n.carousel-dots li, .carousel-dots li button {\n  width: unset !important;\n  height: unset !important;\n}\n\n.carousel-dots li button:before {\n  color: unset !important;\n}\n\n.dashboard-legend {\n  color: black;\n  background-color: unset !important;\n}\n\n.dashboard-legend .legend-items {\n  flex-direction: row;\n}\n\n.dashboard-legend UL > LI .swatch {\n  border-radius: 50% !important;\n}\n\n.legend UL > LI {\n  margin: 5px 7px 0 0;\n}\n\n.dashboard-card-bg-div-1 {\n  height: 270px;\n}\n\n.dashboard-card-bg-div-2 {\n  height: 80px;\n}\n\n.dashboard-card {\n  position: relative;\n  top: -350px;\n}\n\n.row-separater {\n  display: flex;\n  height: 120px;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: 10px;\n}\n\n.property-display1 {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 120px !important;\n}\n\n.property-display2 {\n  width: 49%;\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 10px;\n}\n\n.missed-standard.property-display2 {\n  width: 68%;\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 10px;\n}\n\n.carousel-dots-benchmark-dashboard li.carousel-dots-active {\n  box-sizing: border-box;\n  box-sizing: border-box;\n  background: #4FADA6;\n  height: 4px !important;\n  width: 30px !important;\n}\n\n.carousel-dots-benchmark-dashboard li:not(.carousel-dots-active) {\n  box-sizing: border-box;\n  box-sizing: border-box;\n  background: grey;\n  height: 4px !important;\n  width: 30px !important;\n}\n\n.carousel-dots-benchmark-dashboard li.carousel-dots-active button:before {\n  color: #4FADA6 !important;\n  top: -8px !important;\n  left: -15px !important;\n  font-size: 40px !important;\n  opacity: 1 !important;\n  width: 30px;\n  height: 30px;\n  background: #FFFFFF;\n  border: 0.6px solid #4FADA6;\n  border-radius: 50%;\n}\n\n.carousel-dots-benchmark-dashboard li button:before {\n  line-height: 30px !important;\n  top: -8px !important;\n  left: -15px !important;\n  font-size: 40px !important;\n  opacity: 1 !important;\n  color: grey !important;\n}\n\n.piechartTitleChange {\n  display: inline-block;\n  padding: auto;\n  width: 50%;\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 22px;\n  text-align: center;\n  position: relative;\n  bottom: 90px;\n}\n\n.piechartTitleChangeSpan {\n  border-radius: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.piechartTitleChangeSpanIcon {\n  font-size: 10px;\n  bottom: 2px;\n  position: relative;\n  padding-right: 5px;\n}\n\n.legend {\n  margin-left: auto !important;\n}\n\n.brand-hotel-selector .hotel-selection-dropdown-none .control-select-menu-addon {\n  display: none;\n}\n\n.brand-hotel-selector .hotel-selector-primary {\n  white-space: nowrap;\n}\n\n.brandhotelselector .hotel-selection-dropdown-none .control-select-menu-addon {\n  display: none;\n}\n\n.hotel-selection-dropdown-none.control-select-menu:hover,\n.hotel-selection-dropdown-none.control-select-menu:focus {\n  text-decoration: none !important;\n}\n\n.blur {\n  filter: url(#gaussian-blur);\n  filter: blur(7px);\n  -webkit-filter: blur(7px);\n  position: fixed;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.9);\n  opacity: 0;\n  -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  font-family: Arial, Helvetica, sans-serif;\n  width: 100%;\n  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);\n  color: #666;\n  text-align: center;\n  overflow-y: hidden;\n}\n\n.z-index-100 {\n  z-index: 100;\n  position: fixed;\n  top: 50%;\n  left: 44%;\n  right: 50%;\n  bottom: 50%;\n}\n\n.profile-view-container {\n  position: fixed;\n  top: 160px;\n  height: 100vh !important;\n  background: #08142f;\n  width: 100%;\n  z-index: 1;\n}\n\n.centered-container {\n  display: flex;\n  padding-top: 40px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left; /* Center text inside each div */\n}\n\n.compset-font .bp3-popover-target .control-select-menu-inner .control-select-menu-select {\n  font-size: 11px;\n}\n\n.mt-250 {\n  margin-top: 250px;\n}\n\n.mb-50 {\n  margin-bottom: 50px;\n}\n\n.pending-assessment {\n  top: 200px;\n  position: absolute;\n}\n\n.hotel-selector-primary {\n  font-size: 18px !important;\n  line-height: 20px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
